import { useCallback, useContext, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { getPortfolioFull } from 'src/redux/user_portfolio/thunks';
import {
    selectPortfolioFullError,
    selectPortfolioFullLoadedForParameter,
    selectPortfolioFullLoading,
} from 'src/redux/user_portfolio/user_portfolio.selectors';
import { RetentionSearchContext } from '../search';

/**
 * Carga perezosa del portafolio COMPLETO del usuario para Asignaciones.
 *
 * A diferencia de `useLazyPortfolio` (una sola página, para Vigencias), este hook
 * acumula todas las páginas de slots y propiedades vía `getPortfolioFull`, de modo
 * que Asignaciones conoce la capacidad total (coincide con Vigencias) y puede
 * asignar de forma masiva sobre todos los slots disponibles, no solo los visibles.
 * El guard `loadedForParameter` evita recargas al alternar entre pestañas.
 */
export const useLazyPortfolioFull = () => {
    const dispatch = useAppDispatch();
    const { submittedQuery } = useContext(RetentionSearchContext);
    const loading = useAppSelector(selectPortfolioFullLoading);
    const error = useAppSelector(selectPortfolioFullError);
    const loadedForParameter = useAppSelector(selectPortfolioFullLoadedForParameter);
    const isLoaded = !!submittedQuery && loadedForParameter === submittedQuery;

    useEffect(() => {
        if (!submittedQuery) return;
        if (loading) return;
        if (loadedForParameter === submittedQuery) return;
        dispatch(getPortfolioFull({ parameter: submittedQuery }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submittedQuery]);

    const reload = useCallback(() => {
        if (!submittedQuery) return;
        dispatch(getPortfolioFull({ parameter: submittedQuery }));
    }, [dispatch, submittedQuery]);

    return { submittedQuery, loading, error, isLoaded, reload };
};
